import { Dialog } from "@onmo/ui";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { removePopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import { useTranslation } from "react-i18next";
type IQuitGamePopup = {
  onExit: () => void;
  onResumeGame?: () => void;
};

const QuitGamePopup: React.FC<IQuitGamePopup> = (props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { onExit, onResumeGame } = props;
  const { currentPopupId } = useAppSelector((state) => state.popup);

  const onClickClose = () => {
    dispatch(removePopupQueue({ type: PopupType.QuitGame }));
    onExit();
  };

  const onClickContinue = () => {
    onResumeGame?.();
    dispatch(removePopupQueue({ type: PopupType.QuitGame }));
  };

  return (
    <Dialog
      open={currentPopupId === PopupType.QuitGame}
      mainAction={{
        text: t("not_now"),
        onClick: onClickContinue,
      }}
      secondAction={{
        text: t("exit"),
        onClick: onClickClose,
      }}
      title={t("quit_game_title")}
      description={t("quit_game_description")}
    />
  );
};
export default QuitGamePopup;
